<template>
  <div class="home">
    <section>
      <SiteHero class="text-gray-700 body-font" />
    </section>
    <section id="featured-project" class="text-gray-700 body-font">
      <FeaturedProject />
    </section>
    <section id="skills" class="text-gray-700 body-font bg-gray-200">
      <Skills />
    </section>
    <section id="showcase" class="text-gray-700 body-font overflow-hidden">
      <Showcase />
    </section>
    <section id="contact-me" class="text-gray-700 body-font bg-gray-200">
      <ContactMe />
    </section>
    <section id="about-me" class="text-gray-700 body-font">
      <AboutMe />
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import ContactMe from "@/components/ContactMe.vue";
import AboutMe from "@/components/AboutMe.vue";
import FeaturedProject from "@/components/FeaturedProject.vue";
import Showcase from "@/components/Showcase.vue";
import Skills from "@/components/Skills.vue";
import SiteHero from "@/components/SiteHero.vue";

export default {
  name: "Home",
  components: {
    AboutMe,
    FeaturedProject,
    ContactMe,
    Showcase,
    Skills,
    SiteHero
  }
};
</script>
